import React from 'react'
import { Modal } from 'react-bootstrap'
import ExtraSection from './ExtraSection'

interface Props {
    show: boolean,
    onClose: () => void,
    reservationId: string
}

const AddExtraDialog: React.FC<Props> = ({ show, onClose, reservationId }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Add Extra</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ExtraSection reservationId={reservationId} onClose={onClose} />
            </Modal.Body>
        </Modal>
    )
}

export default AddExtraDialog
